// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RichTextEditorV5 = require("../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedYourProfileAboutForm_agent_graphql = require("../../__generated__/UnifiedYourProfileAboutForm_agent_graphql.bs.js");
let UnifiedYourProfileAboutFormBiographyMutation_graphql = require("../../__generated__/UnifiedYourProfileAboutFormBiographyMutation_graphql.bs.js");

let convertVariables = UnifiedYourProfileAboutFormBiographyMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileAboutFormBiographyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileAboutFormBiographyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedYourProfileAboutFormBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedYourProfileAboutFormBiographyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let BiographyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function usePersonalBiography() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedBiography;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

let validators = {
  biography: undefined,
  specialties: undefined
};

function initialFieldsStatuses(input) {
  return {
    biography: "Pristine",
    specialties: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    biography: "Pristine",
    specialties: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      biography: "Pristine",
      specialties: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, param, param$1) {
  let match_0 = {
    TAG: "Ok",
    _0: input.biography
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.specialties
  };
  let biographyResult = match_0;
  let biographyResult$1;
  if (biographyResult.TAG === "Ok") {
    let specialtiesResult = match_0$1;
    if (specialtiesResult.TAG === "Ok") {
      return {
        TAG: "Valid",
        output: {
          biography: biographyResult._0,
          specialties: specialtiesResult._0
        },
        fieldsStatuses: {
          biography: {
            TAG: "Dirty",
            _0: biographyResult,
            _1: "Hidden"
          },
          specialties: {
            TAG: "Dirty",
            _0: specialtiesResult,
            _1: "Hidden"
          }
        },
        collectionsStatuses: undefined
      };
    }
    biographyResult$1 = biographyResult;
  } else {
    biographyResult$1 = biographyResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      biography: {
        TAG: "Dirty",
        _0: biographyResult$1,
        _1: "Hidden"
      },
      specialties: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurBiographyField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.biography, state.fieldsStatuses.biography, status => {
            let init = state.fieldsStatuses;
            return {
              biography: status,
              specialties: init.specialties
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurSpecialtiesField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.specialties, state.fieldsStatuses.specialties, status => {
            let init = state.fieldsStatuses;
            return {
              biography: init.biography,
              specialties: status
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateBiographyField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.biography, status => {
                let init = state.fieldsStatuses;
                return {
                  biography: status,
                  specialties: init.specialties
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateSpecialtiesField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.specialties, status => {
                let init = state.fieldsStatuses;
                return {
                  biography: init.biography,
                  specialties: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  biography: "Pristine",
                  specialties: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  biography: "Pristine",
                  specialties: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateBiography: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateBiographyField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateSpecialties: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateSpecialtiesField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurBiography: () => dispatch("BlurBiographyField"),
    blurSpecialties: () => dispatch("BlurSpecialtiesField"),
    biographyResult: Formality.exposeFieldResult(state.fieldsStatuses.biography),
    specialtiesResult: Formality.exposeFieldResult(state.fieldsStatuses.specialties),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.biography;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.specialties;
      return typeof tmp$1 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = UnifiedYourProfileAboutForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, UnifiedYourProfileAboutForm_agent_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(UnifiedYourProfileAboutForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UnifiedYourProfileAboutForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(UnifiedYourProfileAboutForm_agent_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function UnifiedYourProfileAboutForm$RichTextField(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.label
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(RichTextEditorV5.make, {
          initialContent: props.initialValue,
          onChange: props.onChange,
          onBlur: props.onBlur,
          toolbar: "withSingleHeadingLevel",
          proseStyle: "md"
        }),
        className: "mt-2 space-y-3 sm:col-span-2 sm:mt-0"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let RichTextField = {
  make: UnifiedYourProfileAboutForm$RichTextField
};

function UnifiedYourProfileAboutForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(UnifiedYourProfileAboutForm_agent_graphql.node, convertFragment, props.agent);
  let match = usePersonalBiography();
  let saveBiography = match[0];
  let match$1 = UnifiedProfileSave.usePersonalProfessionalInfo();
  let saveProfessionalInfo = match$1[0];
  let saving = match[1] || match$1[1];
  let form = useForm({
    biography: agent.biography,
    specialties: agent.specialties
  }, (values, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    saveBiography({
      biography: Stdlib_Option.getOr(values.biography, "")
    }, () => saveProfessionalInfo({
      specialties: Stdlib_Option.getOr(values.specialties, "")
    }, () => notifyOnSuccess(undefined), message => notifyOnFailure("Biography saved. Specialties save could not be confirmed. Use Save changes to retry. " + message)), message => notifyOnFailure(message));
  });
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Account updated"
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx(Alert.$$Error.make, {
          title: message._0
        })
    );
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(UnifiedYourProfileAboutForm$RichTextField, {
              label: "Bio",
              initialValue: agent.biography,
              onChange: value => form.updateBiography((input, value) => ({
                biography: value,
                specialties: input.specialties
              }), value),
              onBlur: param => form.blurBiography()
            }),
            JsxRuntime.jsx(UnifiedYourProfileAboutForm$RichTextField, {
              label: "Specialties",
              initialValue: agent.specialties,
              onChange: value => form.updateSpecialties((input, value) => ({
                biography: input.biography,
                specialties: value
              }), value),
              onBlur: param => form.blurSpecialties()
            })
          ],
          className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              disabled: saving || form.submitting,
              children: "Save changes"
            }),
            JsxRuntime.jsx("div", {
              children: tmp,
              role: "status"
            })
          ],
          className: "flex flex-col items-end gap-3"
        })
      ],
      className: "space-y-6"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let make = UnifiedYourProfileAboutForm;

exports.BiographyMutation = BiographyMutation;
exports.usePersonalBiography = usePersonalBiography;
exports.FormConfig = FormConfig;
exports.Fragment = Fragment;
exports.RichTextField = RichTextField;
exports.make = make;
/* commitMutation Not a pure module */
